import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Istanza axios per le chiamate API
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

/**
 * Crea una nuova notifica
 * @param {Object} data - Dati della notifica
 * @returns {Promise}
 */
export const createNotification = async (data) => {
  const response = await api.post('/notifications', data);
  return response.data;
};

/**
 * Recupera le notifiche dell'utente (paginate)
 * @param {number} page - Numero della pagina
 * @param {number} limit - Limite per pagina
 * @param {boolean} unreadOnly - Se true, restituisce solo non lette
 * @returns {Promise}
 */
export const getNotifications = async (page = 1, limit = 10, unreadOnly = false) => {
  const response = await api.get('/notifications', {
    params: { page, limit, unreadOnly },
  });
  return response.data;
};

/**
 * Recupera il conteggio delle notifiche non lette
 * @returns {Promise}
 */
export const getUnreadCount = async () => {
  const response = await api.get('/notifications/unread-count');
  return response.data.data.unreadCount;
};

/**
 * Segna una notifica come letta
 * @param {string} notificationId - ID della notifica
 * @returns {Promise}
 */
export const markAsRead = async (notificationId) => {
  const response = await api.put(`/notifications/${notificationId}/read`);
  return response.data;
};

/**
 * Segna tutte le notifiche come lette
 * @returns {Promise}
 */
export const markAllAsRead = async () => {
  const response = await api.put('/notifications/mark-all-read');
  return response.data;
};

/**
 * Cancella una notifica (soft delete) - Admin only
 * @param {string} notificationId - ID della notifica
 * @returns {Promise}
 */
export const deleteNotification = async (notificationId) => {
  const response = await api.delete(`/notifications/${notificationId}`);
  return response.data;
};

/**
 * Recupera lo storico notifiche inviate dall'admin - Admin only
 * @param {number} page - Numero della pagina
 * @param {number} limit - Limite per pagina
 * @returns {Promise}
 */
export const getAdminNotificationList = async (page = 1, limit = 20) => {
  const response = await api.get('/notifications/admin/list', {
    params: { page, limit },
  });
  return response.data.data || [];
};

/**
 * Recupera statistiche di una notifica - Admin only
 * @param {string} notificationId - ID della notifica
 * @returns {Promise}
 */
export const getNotificationStats = async (notificationId) => {
  const response = await api.get(`/notifications/admin/${notificationId}/stats`);
  return response.data;
};

export default {
  createNotification,
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  deleteNotification,
  getAdminNotificationList,
  getNotificationStats,
};
